import { observer } from "mobx-react";
import React, { FC } from "react";
import { accountProductsConfigMap } from "constants/account-products-config";
import { ApplicationProductEnum } from "enums/application-product.enum";
import { UserAccountStore } from "store/UserAccounts/UserAccount/UserAccount.store";
import { ProductInfo } from "routes/dashboard/routes/tools/components/ProductInfo/ProductInfo";
import { AspectRatio, Box, Center, Image } from "@chakra-ui/react";
import { SplashScreen } from "routes/dashboard/routes/tools/components/SplashScreen/SplashScreen";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faCheckCircle } from "@fortawesome/pro-regular-svg-icons";
import { InternalLink } from "components";
import { LEADS_ROUTE } from "constants/routes";
import {
  LEAD_RESPONDER_DIAGRAM,
  LEAD_RESPONDER_ILLUSTRATION,
} from "constants/image-paths";
import { SplashScreenReachout } from "routes/dashboard/routes/tools/components/SplashScreen/SplashScreenReachout";

const productConfig =
  accountProductsConfigMap[ApplicationProductEnum.MORTGAGES];

interface IProps {
  accountStore: UserAccountStore;
  isEnabled?: boolean;
}

export const MortgageReferralsSplashScreen: FC<IProps> = observer(
  ({ accountStore, isEnabled }) => {
    return (
      <SplashScreen
        background={"orange.50"}
        topSection={
          <>
            <ProductInfo
              productConfig={productConfig}
              header={
                isEnabled
                  ? "Thank you for activating mortgage referrals."
                  : "You’re missing 88% of your mortgage referrals."
              }
              text={
                isEnabled ? (
                  <Box as={"span"}>
                    LeadPro is now actively identifying and referring mortgage
                    leads for you. You can track mortgage leads in the{" "}
                    <InternalLink as={"span"} href={LEADS_ROUTE}>
                      Leads dashboard
                    </InternalLink>
                    .
                  </Box>
                ) : (
                  "LeadPro carried out research and found that for every 100 potential mortgage referrals: staff manually referred 12 opportunities, while LeadPro automatically picked up the other 88!"
                )
              }
              customBullet={
                <Center color={"orange.600"} flexShrink={0}>
                  <FontAwesomeIcon icon={faCheckCircle} fontSize={28} />
                </Center>
              }
              bulletPoints={[
                "Significantly increase your business's revenue, with more converted mortgage referrals.",
                "Keep your existing mortgage broker, and put an automated safety net in place so you don’t miss any opportunities.",
                "Earn passive referral commission even from buyers that go on to complete with another agent.",
              ]}
              productColor={"orange"}
              colorScheme={"orange"}
              accountBillingStore={accountStore.accountBillingStore}
              customCTA={
                isEnabled ? (
                  <></>
                ) : (
                  <Box mt={8}>
                    <SplashScreenReachout featureName="Mortgage Referrals feature" />
                  </Box>
                )
              }
            />
            <AspectRatio ratio={1} width={"400px"}>
              <Image src={LEAD_RESPONDER_ILLUSTRATION} />
            </AspectRatio>
          </>
        }
        bottomSection={
          <>
            <Box fontSize={"3xl"} fontWeight={700}>
              How it works
            </Box>
            <Box position={"relative"}>
              <Image src={LEAD_RESPONDER_DIAGRAM} />
            </Box>
          </>
        }
      />
    );
  }
);
